import React, { useState, useRef } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import axios from "axios";
import { baseURLV1 } from "../../../service/API.js";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Switch from "@material-ui/core/Switch";
import { Link } from "react-router-dom";
// import "../../../../component.css";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

export const CreateMasterCountryVat = () => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const { authToken } = useSelector((state) => state.auth);
  suhbeader.setTitle(intl.formatMessage({ id: "###",defaultMessage:"Create Master Country Vat" }));
  const history = useHistory();
  const [country, setCountry] = useState();
  const [currencyUnit, setCurrencyUnit] = useState();
  const [countryVatPercent, setCountryVatpercent] = useState();
  const [state, setState] = useState(true);

  const AlertError = (message) => {
    Swal.fire("Create Country Vat!", message, "error");
  };
  const handleChangeSwitch = () => {
    setState(!state);
  };

  const handleSend = async () => {
    if (country === undefined || country === "") {
      return AlertError("Please insert country name !!");
    }
    if (currencyUnit === undefined || currencyUnit === "") {
      return AlertError("Please insert currency unit !!");
    }
    if (countryVatPercent === undefined || countryVatPercent === "") {
      return AlertError("Please insert vat percentage !!");
    }
   
    var events = {
      country: country, 
      currencyUnit: currencyUnit,
      countryVatPercent: countryVatPercent,
      enabled: state,
    };

    let apiUrls = `${baseURLV1}/dynamic/countryVats`;
    axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      data: events,
    })
      .then(async (res) => {
        Swal.fire("Save !", "Save country vat success", "success");
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Created !",
          "Your can not create country vat. !! " + err,
          "error"
        );
      });
  };

  return (
    <Card>
      <CardHeader title={intl.formatMessage({ id: "###",defaultMessage:"Create Master Country Vat" })}></CardHeader>
      <CardBody>
        <div className="container">
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Country Name"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(country) => setCountry(country.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Currency Unit"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(currencyUnit) => setCurrencyUnit(currencyUnit.target.value)}
            />
          </div>
          
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Vat Percentage"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(countryVatPercent) => setCountryVatpercent(countryVatPercent.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/MasterCountryVat">
              <button type="button" className="btn btn-secondary wbt">
                {intl.formatMessage({ id: "###",defaultMessage:"Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => handleSend()}>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Save"})}
            </button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
